export class CategorizationChangeEvent {
    public category1Id : number ;
    public category2Id : number ;
    public category3Id : number ;
}
